import type { OptionDefinition } from "../types.ts";

export const microphoneOptions: OptionDefinition[] = [
  {
    key: "microphoneDetection",
    type: "arrayToggle",
    default: undefined,
    valueWhenTrue: ["handsFree"],
    label: "Enable Microphone",
    tab: "microphone",
  },
  {
    key: "debugMicrophone",
    type: "boolean",
    default: false,
    label: "Debug Microphone",
    tab: "microphone",
  },
];
